import { render, staticRenderFns } from "./CellCard.vue?vue&type=template&id=2da550b1"
import script from "./CellCard.vue?vue&type=script&lang=js"
export * from "./CellCard.vue?vue&type=script&lang=js"
import style0 from "./CellCard.vue?vue&type=style&index=0&id=2da550b1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports